import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { User } from '../../models/user';
import { GlobalProvider } from '../../providers/global/global';

@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  user = {} as User;
  data: Observable<any>;
  deleteVisible: boolean = true;
  registerVisible: boolean = true;
  isenabled: boolean = true;

  senhaVisible: boolean = false;
  teste: boolean = false;
  alterarSenhaCheckbox: boolean = false;
  notificationCheckbox: boolean = false;

  level: any = 4;
  level1Visible: boolean = true;
  level2Visible: boolean = true;
  level3Visible: boolean = true;
  level4Visible: boolean = true;

  operacao: any;
  permissions: any[];

  notifications: any[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: HttpClient,
    public global: GlobalProvider,
    public alerCtrl: AlertController
  ) {

    if (this.global.novoUsuario == true) {
      this.isenabled = true;
      this.registerVisible = true;
      this.deleteVisible = false;
      this.senhaVisible = false;
      this.global.changePassword = false;
    }
    else if (this.global.editarUsuario == true) {
      this.isenabled = false;
      this.deleteVisible = true;
      this.registerVisible = false;
      this.senhaVisible = false;
      this.notificationCheckbox = this.global.notifCheckBox;
      this.level = this.global.level;
      this.permissions = this.global.userPermissions;
      this.notifications = this.global.userNotifications;
    }

    this.user.firstName = this.global.firstName;
    this.user.lastName = this.global.lastName;
    this.user.email = this.global.email;
    this.user.userName = this.global.userName;

    if (this.global.securityLevel == 1) {
      this.level1Visible = false;
    }
    else if (this.global.securityLevel == 2) {
      this.level1Visible = false;
      this.level2Visible = false;
    }
    else if (this.global.securityLevel == 3 || this.global.securityLevel == 4) {
      this.level1Visible = false;
      this.level2Visible = false;
      this.level3Visible = false;
    }
    
    this.global.changeUserPermissions = (this.global.securityLevel == 0) ? true : false;
    this.global.hideRoot = (this.global.securityLevel == 0) ? false : true;
  }

  changePassword() {
    if (this.alterarSenhaCheckbox == true) {
      this.senhaVisible = true;
    }
    else {
      this.senhaVisible = false;
    }
  }

  register_options(user: User) {
    //Notifications (areaAccess)
    if (this.global.securityLevel == 0) {
      if (this.notifications == undefined) {
        this.global.setUserNotifications = (this.notificationCheckbox) ? this.global.banco + "_mg" : null;
      }
      else {
        this.global.setUserNotifications = "";
        for (let i = 0; i < this.notifications.length; i++) {
          this.global.setUserNotifications = this.global.setUserNotifications + this.notifications[i] + ";";
        }
        this.global.setUserNotifications = this.global.setUserNotifications.slice(0, -1);
      }
    }
    else {
      this.global.setUserNotifications = (this.notificationCheckbox) ? this.global.banco + "_mg" : null;
    }
    //console.log(this.global.setUserNotifications);

    //UserPermissions
    if (this.permissions == undefined) {
      this.global.setUserPermissions = this.global.banco;
    }
    else {
      this.global.setUserPermissions = "";
      for (let i = 0; i < this.permissions.length; i++) {
        this.global.setUserPermissions = this.global.setUserPermissions + this.permissions[i] + ";";
      }
      this.global.setUserPermissions = this.global.setUserPermissions.slice(0, -1);
    }

    this.register(user);
  }

  register(user) {
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/global_users/register';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', 'users');
      body.append('tabela', 'global_users');
      body.append('firstName', user.firstName);
      body.append('lastName', user.lastName);
      body.append('email', user.email);
      body.append('userName', user.userName);
      body.append('password', user.password);
      body.append('agent', this.global.userId);
      body.append('areaAccess', this.global.setUserNotifications);
      body.append('securityLevel', this.level);
      body.append('userPermissions', this.global.setUserPermissions);
      body.append('pass', this.global.password);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        //console.log(data);
        if (data.concluded == 1) {
          this.user_log(user, "user_add");
        }
        document.getElementById("result_register").innerHTML = data.result;
        alert(data.result);
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  delete(user: User) {
    let confirm = this.alerCtrl.create({
      title: 'Deseja realmente deletar?',
      //message: '',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Confirmar',
          handler: () => {
            console.log('Agree clicked');
            try {
              var url = 'http://iot.digicomp.com.br/api/public/ping/global_users/delete';
              this.global.check_jwt();

              let body = new FormData();
              body.append('db', 'users');
              body.append('tabela', 'global_users');
              body.append('userName', user.userName);
              body.append('agent', this.global.userId);
              body.append('pass', this.global.password);
              body.append('jwt', this.global.token);

              this.data = this.http.post(url, body);
              this.data.subscribe(data => {
                //console.log(data);
                if (data.concluded == 1) {
                  this.user_log(user, "user_delete");
                }
                document.getElementById("result_register").innerHTML = data.result;
                alert(data.result);
              });
            }
            catch (e) {
              console.error(e);
            }
          }
        }
      ]
    });
    confirm.present()
  }

  edit_options(user: User) {
    //Notifications (areaAccess)
    if (this.global.securityLevel == 0) {
      if (this.notifications == undefined) {
        this.global.setUserNotifications = (this.notificationCheckbox) ? this.global.banco + "_mg" : null;
      }
      else {
        this.global.setUserNotifications = "";
        for (let i = 0; i < this.notifications.length; i++) {
          this.global.setUserNotifications = this.global.setUserNotifications + this.notifications[i] + ";";
        }
        this.global.setUserNotifications = this.global.setUserNotifications.slice(0, -1);
      }
    }
    else {
      this.global.setUserNotifications = (this.notificationCheckbox) ? this.global.banco + "_mg" : null;
    }

    //console.log(this.global.setUserNotifications);

    //UserPermissions
    this.global.setUserPermissions = "";
    for (let i = 0; i < this.permissions.length; i++) {
      this.global.setUserPermissions = this.global.setUserPermissions + this.permissions[i] + ";";
    }
    this.global.setUserPermissions = this.global.setUserPermissions.slice(0, -1);

    if (this.alterarSenhaCheckbox) {
      this.edit_password(user);
    }
    else {
      this.edit(user);
    }

  }

  edit(user) {
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/global_users/edit';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', 'users');
      body.append('tabela', 'global_users');
      body.append('firstName', user.firstName);
      body.append('lastName', user.lastName);
      body.append('email', user.email);
      body.append('userName', user.userName);
      body.append('areaAccess', this.global.setUserNotifications);
      body.append('securityLevel', this.level);
      body.append('agent', this.global.userId);
      body.append('agentSecurity', this.global.securityLevel);
      body.append('pass', this.global.password);
      body.append('userPermissions', this.global.setUserPermissions);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        //console.log(data);
        if (data.concluded == 1) {
          this.user_log(user, "user_edit");
        }
        document.getElementById("result_register").innerHTML = data.result;
        alert(data.result);
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  edit_password(user) {
    try {
      var url = 'http://iot.digicomp.com.br/api/public/global_users/edit_password';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', 'users');
      body.append('tabela', 'global_users');
      body.append('firstName', user.firstName);
      body.append('lastName', user.lastName);
      body.append('email', user.email);
      body.append('userName', user.userName);
      body.append('areaAccess', this.global.areaAccess);
      body.append('securityLevel', this.level);
      body.append('agent', this.global.userId);
      body.append('oldPassword', user.oldPassword);
      body.append('newPassword', user.newPassword);
      body.append('confirmPassword', user.confirmPassword);
      body.append('agentSecurity', this.global.securityLevel);
      body.append('pass', this.global.password);
      body.append('userPermissions', this.global.setUserPermissions);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        //console.log(data);
        if (data.concluded == 1) {
          this.user_log(user, "user_edit_password");
        }
        document.getElementById("result_register").innerHTML = data.result;
        alert(data.result);
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  user_log(user, operacao) {
    if (operacao == "user_add") {
      this.global.operacao = "{" + '"' + "firstName" + '"' + ":" + '"' + user.firstName + '"' + ", " + '"' + "lastName" + '"' + ":" + '"' + user.lastName + '"' + ", " + '"' + "email" + '"' + ":" + '"' + user.email + '"' + ", " + '"' + "userName" + '"' + ":" + '"' + user.userName + '"' + ", " + '"' + "notification" + '"' + ":" + '"' + this.notificationCheckbox + '"' + ", " + '"' + "securityLevel" + '"' + ":" + '"' + this.level + '"' + ", " + '"' + "userPermissions" + '"' + ":" + '"' + this.global.setUserPermissions + '"' + "}";
    }
    else if (operacao == "user_edit") {
      this.global.operacao = "{" + '"' + "firstName" + '"' + ":" + '"' + user.firstName + '"' + ", " + '"' + "lastName" + '"' + ":" + '"' + user.lastName + '"' + ", " + '"' + "email" + '"' + ":" + '"' + user.email + '"' + ", " + '"' + "userName" + '"' + ":" + '"' + user.userName + '"' + ", " + '"' + "notification" + '"' + ":" + '"' + this.notificationCheckbox + '"' + ", " + '"' + "securityLevel" + '"' + ":" + '"' + this.level + '"' + ", " + '"' + "userPermissions" + '"' + ":" + '"' + this.global.setUserPermissions + '"' + "}";
    }
    else if (operacao == "user_edit_password") {
      this.global.operacao = "{" + '"' + "firstName" + '"' + ":" + '"' + user.firstName + '"' + ", " + '"' + "lastName" + '"' + ":" + '"' + user.lastName + '"' + ", " + '"' + "email" + '"' + ":" + '"' + user.email + '"' + ", " + '"' + "userName" + '"' + ":" + '"' + user.userName + '"' + ", " + '"' + "password" + '"' + ":" + '"' + "***" + '"' + ", " + '"' + "notification" + '"' + ":" + '"' + this.notificationCheckbox + '"' + ", " + '"' + "securityLevel" + '"' + ":" + '"' + this.level + '"' + ", " + '"' + "userPermissions" + '"' + ":" + '"' + this.global.setUserPermissions + '"' + "}";
    }
    else if (operacao == "user_delete") {
      this.global.operacao = "{" + '"' + "firstName" + '"' + ":" + '"' + user.firstName + '"' + ", " + '"' + "lastName" + '"' + ":" + '"' + user.lastName + '"' + ", " + '"' + "email" + '"' + ":" + '"' + user.email + '"' + ", " + '"' + "userName" + '"' + ":" + '"' + user.userName + '"' + ", " + '"' + "notification" + '"' + ":" + '"' + this.notificationCheckbox + '"' + ", " + '"' + "securityLevel" + '"' + ":" + '"' + this.level + '"' + "}";;
    }

    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/global_users/log';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', 'users');
      body.append('tabela', 'users_log');
      body.append('agent', this.global.userId);
      body.append('client', this.global.banco);
      body.append('operacao', operacao);
      body.append('detalhes', this.global.operacao);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        //console.log(data);
      });
    }
    catch (e) {
      console.error(e);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts